export default "__VITE_ASSET__CekDcjBA__"